let csrfToken: string | null = null;

export class ApiResponseError extends Error {
  constructor(public status: number, message: string) { super(message); }
}

export async function apiJson<T>(url: string, init: RequestInit = {}): Promise<T> {
  const response = await fetch(url, { credentials: "same-origin", ...init, headers: { ...(init.body ? { "Content-Type": "application/json" } : {}), ...init.headers } });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) throw new ApiResponseError(response.status, body?.error?.message ?? "The request could not be completed.");
  return body as T;
}

export async function getCsrfToken(): Promise<string> {
  if (csrfToken) return csrfToken;
  const result = await apiJson<{ csrfToken: string }>("/api/admin/auth/csrf");
  csrfToken = result.csrfToken;
  return csrfToken;
}

export async function adminMutation<T>(url: string, method: "POST" | "PATCH", body?: unknown): Promise<T> {
  const token = await getCsrfToken();
  return apiJson<T>(url, { method, headers: { "x-csrf-token": token }, ...(body === undefined ? {} : { body: JSON.stringify(body) }) });
}

export function clearAdminApiState() { csrfToken = null; }
